// extracted by mini-css-extract-plugin
export default {"root":"ConversationMenu_root__U5vre"};